import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';

export const EntityTestContent = () => {
  const { entity } = useEntity();

  return (
    <div>
      <h2>Entity from Backstage</h2>

      <p>
        <b>Name:</b> {entity.metadata.name}
      </p>

      <p>
        <b>Kind:</b> {entity.kind}
      </p>
    </div>
  );
};

